<script>
    import { userDetails } from "../stores";
    import LoyaltyCard from "./LoaltyCard.svelte";

</script>

{#if $userDetails?.loyaltyCards}
    <div class="cards">
        {#each Object.values($userDetails.loyaltyCards) as card}
            <LoyaltyCard {card} />
        {/each}
    </div>
{/if}

<style>
    /* your styles go here */
    .cards {
        width: 100%;
        max-width: 752px;
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        margin-left: auto;
        margin-right: auto;
        gap: 80px;
        margin-top: 50px;
    }

</style>
